<template>
  <view class="modal-footer-slot-with-cancel-demo">
    <cube-modal
      wx:ref="modal"
      title="我是标题~"
      content="我是正文我是正文我是正文我是正文我是正文我是正文"
      direction="horizontal"
      cancel-text="取消"
      mask-closable="{{ true }}"
      no-built-in-btns="{{ true }}"
    >
      <cube-confirm-button-group

        slot="footer"
        type="confirm"
        bind:confirm="onConfirm"
      />
      <view class="model-footer" slot="footer">起点不在此机场</view>
    </cube-modal>
    <cube-button  bind:click="onTap">modal-footer-slot</cube-button>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    methods: {
      onTap() {
        this.$refs.modal.show()
      },
      onConfirm() {
        this.$refs.modal.hide()
        console.log('click the confirm btn')
      }
    }
  })
</script>

<style lang="stylus">
.modal-footer-slot-with-cancel-demo
  .model-footer
    margin-top 15px
    text-align center
    font-size 16px
    color #757575
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-modal": "@mpxjs/mpx-cube-ui/src/components/modal/index",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-confirm-button-group": "@mpxjs/mpx-cube-ui/src/components/modal/confirm-button-group/index"
    }
  }
</script>
